import { getCurrentInstance } from 'vue'

export default function useGlobal(): any {
  const instance = getCurrentInstance()

  if (!instance) return

  return instance.appContext.config.globalProperties
}
